import { reasons } from '@/modules/attendance/entities/reasons/reasons.constants';
import { AttendanceReasonVisibilityGroup } from '@/modules/attendance/entities/reasons/reasons.enums';
import { useBillingModel } from '@/modules/billing/hooks/useBillingModel';
import { extractSelectOptions } from '@/utils/extractSelectOptions';

export interface UseReasonAndSubReasonLocalProps {
  reasonValue?: string | null;
}

export const REASON_TEXT_PATH = 'label';
export const REASON_VALUE_PATH = 'value';
export const SUB_REASON_TEXT_PATH = 'label';
export const SUB_REASON_VALUE_PATH = 'value';

export const useReasonAndSubReasonLocal = ({ reasonValue }: UseReasonAndSubReasonLocalProps) => {
  const { isCompanyFeeForLife } = useBillingModel();

  const filteredReasons = reasons.filter((reason) =>
    isCompanyFeeForLife
      ? reason.visibilityGroup.includes(AttendanceReasonVisibilityGroup.FEE_FOR_LIFE)
      : true,
  );

  const reasonOptions = extractSelectOptions(filteredReasons, REASON_TEXT_PATH, REASON_VALUE_PATH);

  const filteredSubReasons =
    reasons
      .find((reason) => reason.value === reasonValue)
      ?.subReasons.filter((subReason) =>
        isCompanyFeeForLife
          ? subReason.visibilityGroup.includes(AttendanceReasonVisibilityGroup.FEE_FOR_LIFE)
          : true,
      ) || [];

  const subReasonOptions = extractSelectOptions(
    filteredSubReasons,
    SUB_REASON_TEXT_PATH,
    SUB_REASON_VALUE_PATH,
  );

  return {
    reasonOptions,
    subReasonOptions,
  };
};
